export default {
  name: 'hr',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'OK',
      clear: 'Očisti',
      defaultLabel: 'color picker', // to be translated
      description:
        'current color is {color}. press enter to select a new color.', // to be translated
      alphaLabel: 'pick alpha value', // to be translated
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'Sada',
      today: 'Danas',
      cancel: 'Otkaži',
      clear: 'Očisti',
      confirm: 'OK',
      dateTablePrompt:
        'Use the arrow keys and enter to select the day of the month', // to be translated
      monthTablePrompt: 'Use the arrow keys and enter to select the month', // to be translated
      yearTablePrompt: 'Use the arrow keys and enter to select the year', // to be translated
      selectedDate: 'Selected date', // to be translated
      selectDate: 'Odaberi datum',
      selectTime: 'Odaberi vrijeme',
      startDate: 'Datum početka',
      startTime: 'Vrijeme početka',
      endDate: 'Datum završetka',
      endTime: 'Vrijeme završetka',
      prevYear: 'Prethodna godina',
      nextYear: 'Sljedeća godina',
      prevMonth: 'Prethodni mjesec',
      nextMonth: 'Sljedeći mjesec',
      year: '',
      month1: 'Siječanj',
      month2: 'Veljača',
      month3: 'Ožujak',
      month4: 'Travanj',
      month5: 'Svibanj',
      month6: 'Lipanj',
      month7: 'Srpanj',
      month8: 'Kolovoz',
      month9: 'Rujan',
      month10: 'Listopad',
      month11: 'Studeni',
      month12: 'Prosinac',
      weeks: {
        sun: 'Ned',
        mon: 'Pon',
        tue: 'Uto',
        wed: 'Sri',
        thu: 'Čet',
        fri: 'Pet',
        sat: 'Sub',
      },
      weeksFull: {
        sun: 'Sunday', // to be translated
        mon: 'Monday', // to be translated
        tue: 'Tuesday', // to be translated
        wed: 'Wednesday', // to be translated
        thu: 'Thursday', // to be translated
        fri: 'Friday', // to be translated
        sat: 'Saturday', // to be translated
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec',
      },
    },
    inputNumber: {
      decrease: 'decrease number', // to be translated
      increase: 'increase number', // to be translated
    },
    select: {
      loading: 'Učitavanje',
      noMatch: 'Nema pronađenih podataka',
      noData: 'Nema podataka',
      placeholder: 'Izaberi',
    },
    mention: {
      loading: 'Učitavanje',
    },
    dropdown: {
      toggleDropdown: 'Toggle Dropdown', // to be translated
    },
    cascader: {
      noMatch: 'Nema pronađenih podataka',
      loading: 'Učitavanje',
      placeholder: 'Izaberi',
      noData: 'Nema podataka',
    },
    pagination: {
      goto: 'Idi na',
      pagesize: '/stranica',
      total: 'Ukupno {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
      deprecationWarning:
        'Deprecated usages detected, please refer to the el-pagination documentation for more details', // to be translated
    },
    dialog: {
      close: 'Close this dialog', // to be translated
    },
    drawer: {
      close: 'Close this dialog', // to be translated
    },
    messagebox: {
      title: 'Poruka',
      confirm: 'OK',
      cancel: 'Otkaži',
      error: 'Pogrešan unos',
      close: 'Close this dialog', // to be translated
    },
    upload: {
      deleteTip: 'pritisnite izbriši za brisanje',
      delete: 'Izbriši',
      preview: 'Pregled',
      continue: 'Nastavak',
    },
    slider: {
      defaultLabel: 'slider between {min} and {max}', // to be translated
      defaultRangeStartLabel: 'pick start value', // to be translated
      defaultRangeEndLabel: 'pick end value', // to be translated
    },
    table: {
      emptyText: 'Nema podataka',
      confirmFilter: 'Potvrdi',
      resetFilter: 'Resetiraj',
      clearFilter: 'Sve',
      sumText: 'Suma',
      selectAllLabel: 'Select all rows', // to be translated
      selectRowLabel: 'Select this row', // to be translated
      expandRowLabel: 'Expand this row', // to be translated
      collapseRowLabel: 'Collapse this row', // to be translated
      sortLabel: 'Sort by {column}', // to be translated
      filterLabel: 'Filter by {column}', // to be translated
    },
    tag: {
      close: 'Close this tag', // to be translated
    },
    tour: {
      next: 'Next', // to be translated
      previous: 'Previous', // to be translated
      finish: 'Finish', // to be translated
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'Nema podataka',
    },
    transfer: {
      noMatch: 'Nema pronađenih podataka',
      noData: 'Nema podataka',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Unesite ključnu riječ',
      noCheckedFormat: '{total} stavki',
      hasCheckedFormat: '{checked}/{total} checked',
    },
    image: {
      error: 'FAILED', // to be translated
    },
    pageHeader: {
      title: 'Back', // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No', // to be translated
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
    inputOTP: {
      groupLabel: 'OTP Input', // to be translated
      defaultLabel: 'Please enter OTP character {index}', // to be translated
    },
  },
}
